import React from 'react';
import { CheckIcon } from 'lucide-react';
import { LinkButton } from './ui/Button';
import { Pill } from './ui/Pill';
import { WhatsAppIcon } from './ui/WhatsAppIcon';
import { OrigenChip } from './origen/OrigenChip';
import { waLink } from '../utils/whatsapp';
const guarantees = ['Sin costo por orientación inicial', 'Te explicamos todo antes de empezar', 'Sin compromiso hasta que decidas'];
export function FinalCta() {
  return <section className="relative overflow-hidden bg-primary py-16 lg:py-[100px]" aria-labelledby="cierre-title" data-id="element-23" data-mp="1jbk4brt9s72u">
      <div className="sc-dots absolute inset-0 opacity-[0.5]" aria-hidden="true" data-id="element-24" data-mp="1ebxt1nx050wo" />
      <div aria-hidden="true" className="absolute -bottom-24 -right-20 h-[380px] w-[380px] rounded-[46%_54%_38%_62%/52%_40%_60%_48%] bg-secondary/[0.08]" data-id="element-25" data-mp="1t2erqzi95cpv" />
      <div aria-hidden="true" className="absolute -left-16 -top-20 h-[220px] w-[220px] rounded-[52%_48%_60%_40%/44%_56%_44%_56%] bg-white/[0.04]" data-id="element-26" data-mp="224o3fsp9bc4u" />

      <div className="relative mx-auto flex max-w-[700px] flex-col items-center px-5 text-center" data-id="element-27" data-mp="n5uma2yndpha">
        <Pill tone="aqua" data-id="element-28" data-mp="s45te5xk5lvt">Da el primer paso hoy</Pill>
        <h2 id="cierre-title" className="mt-4 font-display text-[28px] font-bold leading-[1.2] text-white lg:text-[40px]" data-id="element-29" data-mp="s4xozgr5njm3">
          Tu sonrisa merece una atención que realmente la cuide.
        </h2>
        <p className="mt-5 max-w-[600px] font-sans text-[18px] leading-[1.6] text-white/80" data-id="element-30" data-mp="164gkna2s52hi">
          Da el primer paso hoy. No tienes que saber exactamente qué necesitas. Cuéntanos lo que sientes y te orientamos
          desde el primer mensaje.
        </p>

        <LinkButton variant="whatsapp" size="lg" href={waLink('Hola, quiero agendar mi valoración odontológica. No sé exactamente por dónde empezar.')} target="_blank" rel="noreferrer" className="mt-9 shadow-wa-lg" data-id="element-31" data-mp="1furz3qk3au2n">
          <WhatsAppIcon className="h-6 w-6" data-id="element-32" data-mp="1tryhhk0wiqrc" />
          Agendar valoración por WhatsApp
        </LinkButton>
        <p className="mt-3 max-w-[380px] font-sans text-[14px] italic leading-[1.6] text-white/55" data-id="element-33" data-mp="3qsb2imscjjhu">
          Respuesta en horario de atención. Sin formularios ni trámites.
        </p>

        <OrigenChip layout="flow" order={6} dark data-id="element-34" data-mp="3iwajal8hs5b">
          «No tienes que saber exactamente qué necesitas» es la frase más importante del cierre. Elimina la parálisis del
          paciente que no agendó porque no sabía qué decir. Baja el compromiso percibido al mínimo posible.
        </OrigenChip>

        <ul className="mt-12 flex flex-col items-center gap-3 sm:flex-row sm:flex-wrap sm:justify-center sm:gap-x-2" data-id="element-35" data-mp="8ise58q0rhkc">
          {guarantees.map((item, index) => <li key={item} className="flex items-center gap-2" data-id="element-36" data-mp="ifx47jmzjx6f" data-mpi={index}>
              {index > 0 && <span className="hidden text-white/35 sm:mr-2 sm:inline" data-id="element-37" data-mp="2o7ak1jcufy4s">·</span>}
              <CheckIcon className="h-4 w-4 shrink-0 text-white/70" strokeWidth={2.4} data-id="element-38" data-mp="2k68l73mu9o3c" />
              <span className="font-sans text-[14px] text-white/65" data-id="element-39" data-mp="2k8la60r0kypw">{item}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}